import script from "./SettingsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDropdown.vue?vue&type=style&index=0&id=31ff0bab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ff0bab"]])

export default __exports__